import { render, staticRenderFns } from "./Inquire.vue?vue&type=template&id=c4b76cf6&scoped=true&"
import script from "./Inquire.vue?vue&type=script&lang=js&"
export * from "./Inquire.vue?vue&type=script&lang=js&"
import style0 from "./Inquire.vue?vue&type=style&index=0&id=c4b76cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b76cf6",
  null
  
)

export default component.exports